/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

import * as overrides from '../../operation-overrides/deleteIntegrationConfigurationOverrides';

export type DeleteIntegrationConfigurationPathParams = NonNullable<
  operations['deleteIntegrationConfiguration']['parameters']['path']
>;

export interface Input extends DeleteIntegrationConfigurationPathParams {
  apiVersion?: string;
}

export async function deleteIntegrationConfiguration(
  { apiVersion, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().DELETE('/api/v2/integration-configurations/{integrationConfigurationId}', {
    params: { path },
    headers: mergeHeaders(headers, { 'LD-API-Version': apiVersion ?? overrides.apiVersion }),
    signal,
  });
}
